import React from 'react';
import css from './LoadingComponent.scss';
import cx from 'classnames';

const LoadingComponent = props => {
    const { alignCenter = true } = props;

    return (
        <div className={cx(css.ldsroller, alignCenter ? css.absoluteCenter : '')}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    );
};

export default LoadingComponent;
